module.exports = __webpack_public_path__ + "static/media/9thSlide.7b304893.mp3";